<template>
    <b-card
        no-body
        :class="{'open': visible}"
        @mouseenter="collapseOpen"
        @mouseleave="collapseClose"
    >
        <b-card-header
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :class="{'collapsed': !visible, 'disabled': disabled}"
            :aria-expanded="visible ? 'true' : 'false'"
            :aria-controls="collapseItemID"
            role="tab"
            data-toggle="collapse"
            @click="isCollapsible ? updateVisible(!visible) : true"
        >
            <slot name="header">
                <span class="lead collapse-title">{{ title }}</span>
            </slot>
        </b-card-header>

        <b-collapse
            :id="collapseItemID"
            v-model="visible"
            :accordion="accordion"
            :no-animation="noAnimation"
            role="tabpanel"
        >
            <b-card-body :class="cardBodyClass">
                <slot />
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
import {
    BCard, BCardHeader, BCardBody, BCollapse,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'

export default {
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        BCollapse,
    },
    props: {
        cardBodyClass: {
            type: [String, Array, Object],
            default: '',
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
        controlled: {
            type: Boolean,
            default: false,
        },
        headerBgVariant: {
            type: String,
            default: 'white',
        },
        headerTextVariant: {
            type: String,
            default: 'default',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        isCollapsible: {
            type: Boolean,
            default: true,
        },
        noAnimation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            visible: false,
            collapseItemID: '',
            openOnHover: this.$parent.hover,
        }
    },
    computed: {
        accordion() {
            return this.$parent.accordion ? `accordion-${this.$parent.collapseID}` : null
        },
    },
    watch: {
        isVisible(value) {
            if (this.controlled) {
                this.visible = value
            }
        },
    },
    created() {
        this.collapseItemID = uuidv4()
        this.visible = this.isVisible
    },
    methods: {
        isCollapsed() {
            return !this.visible
        },
        updateVisible(val = true) {
            if (!this.disabled) {
                this.visible = val
                this.$emit('visible', val)
            }
        },
        collapseOpen() {
            if (this.openOnHover) this.updateVisible(true)
        },
        collapseClose() {
            if (this.openOnHover) this.updateVisible(false)
        },
    },
}
</script>
<style lang="scss">
.card-header.collapsed.disabled {
    .collapse-title {
        color: #b7c0c9 !important;
    }

    cursor: auto;
}
</style>
